import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { User as UserIcon } from 'lucide-react';
import type { User } from '../../types/index.js';
import type { NavTab } from './NavLinks.js';
import { PWAInstallButton } from '../PWAInstallButton.js';

interface MobileNavDrawerProps {
  isOpen: boolean;
  currentTab: NavTab;
  user: User | null;
  onSelectTab: (tab: NavTab) => void;
  onCloseMobileNav: () => void;
  onOpenProfile?: () => void;
}

export const MobileNavDrawer: React.FC<MobileNavDrawerProps> = ({
  isOpen,
  currentTab,
  user,
  onSelectTab,
  onCloseMobileNav,
  onOpenProfile,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}
          className="md:hidden border-t border-slate-200 bg-white px-4 pt-2 pb-4 space-y-1 text-sm font-semibold overflow-hidden"
        >
          <button
            type="button"
            onClick={() => {
              onSelectTab('landing');
              onCloseMobileNav();
            }}
            className={`w-full text-left px-3 py-2.5 rounded-xl cursor-pointer ${
              currentTab === 'landing' ? 'bg-indigo-50 text-indigo-600' : 'text-slate-700'
            }`}
          >
            Halaman Utama
          </button>

          <button
            type="button"
            onClick={() => {
              onSelectTab('showcase-directory');
              onCloseMobileNav();
              window.history.pushState({}, '', '/direktori');
            }}
            className={`w-full text-left px-3 py-2.5 rounded-xl cursor-pointer ${
              currentTab === 'showcase-directory' || currentTab === 'showcase' ? 'bg-indigo-50 text-indigo-600' : 'text-slate-700'
            }`}
          >
            Direktori Publik
          </button>

          <button
            type="button"
            onClick={() => {
              onSelectTab('blog');
              onCloseMobileNav();
              window.history.pushState({}, '', '/blog');
            }}
            className={`w-full text-left px-3 py-2.5 rounded-xl cursor-pointer ${
              currentTab === 'blog' ? 'bg-indigo-50 text-indigo-600' : 'text-slate-700'
            }`}
          >
            Blog Literasi
          </button>

          {user && (
            <>
              <button
                type="button"
                onClick={() => {
                  onSelectTab('books');
                  onCloseMobileNav();
                }}
                className={`w-full text-left px-3 py-2.5 rounded-xl cursor-pointer ${
                  currentTab === 'books' ? 'bg-indigo-50 text-indigo-600' : 'text-slate-700'
                }`}
              >
                Katalog & Manajemen Buku
              </button>
              <button
                type="button"
                onClick={() => {
                  onSelectTab('dashboard');
                  onCloseMobileNav();
                }}
                className={`w-full text-left px-3 py-2.5 rounded-xl cursor-pointer ${
                  currentTab === 'dashboard' ? 'bg-indigo-50 text-indigo-600' : 'text-slate-700'
                }`}
              >
                Statistik Real-Time
              </button>
              <button
                type="button"
                onClick={() => {
                  onSelectTab('history');
                  onCloseMobileNav();
                }}
                className={`w-full text-left px-3 py-2.5 rounded-xl cursor-pointer ${
                  currentTab === 'history' ? 'bg-indigo-50 text-indigo-600' : 'text-slate-700'
                }`}
              >
                Histori Pemindaian
              </button>
              {user.role === 'admin' && (
                <button
                  type="button"
                  onClick={() => {
                    onSelectTab('api-docs');
                    onCloseMobileNav();
                  }}
                  className={`w-full text-left px-3 py-2.5 rounded-xl cursor-pointer ${
                    currentTab === 'api-docs' ? 'bg-indigo-50 text-indigo-700' : 'text-slate-700'
                  }`}
                >
                  Panel Kontrol Admin
                </button>
              )}
            </>
          )}

          {user && (
            <button
              type="button"
              id="btn-mobile-nav-profile"
              onClick={() => {
                onCloseMobileNav();
                if (onOpenProfile) {
                  onOpenProfile();
                } else {
                  onSelectTab('profile');
                }
              }}
              className={`w-full text-left px-3 py-2.5 rounded-xl flex items-center justify-between cursor-pointer ${
                currentTab === 'profile' ? 'bg-indigo-50 text-indigo-600' : 'text-indigo-600 bg-indigo-50/50'
              }`}
            >
              <div className="flex items-center gap-2">
                <UserIcon className="w-4 h-4 text-indigo-600" />
                <span>Profil Akun ({user.name})</span>
              </div>
              <span className="text-xs font-semibold">&rarr;</span>
            </button>
          )}

          <div className="pt-2 border-t border-slate-100">
            <PWAInstallButton className="w-full justify-center py-2.5" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
